import { useCallback } from "react"
import { Button, Flex } from "@chakra-ui/react"

import { selectDepositStatus, useDappSelector } from "#/redux-state"
import TransactionProgressLoader from "#/shared/components/TransactionProgressLoader"
import { useBlockDepositButton, useDeposit } from "#/shared/hooks"

type DepositModalButtonProps = {
  onClick: () => void
}

export default function DepositModalButton({
  onClick,
}: DepositModalButtonProps) {
  const depositStatus = useDappSelector(selectDepositStatus)

  const { deposit } = useDeposit()
  const shouldBlockButton = useBlockDepositButton()

  const buttonClickHandler = useCallback(() => {
    onClick()
    deposit()
  }, [onClick, deposit])

  return (
    <Flex w="100%" justifyContent="center">
      <Button
        variant={shouldBlockButton ? "disabled" : "primary"}
        size="large"
        onClick={buttonClickHandler}
      >
        {depositStatus === "pending" ? (
          <TransactionProgressLoader text="Waiting for deposit..." />
        ) : (
          "Deposit BTC"
        )}
      </Button>
    </Flex>
  )
}
